import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { LocalStorageService } from "@dodo/local-storage";
import { EnvConfigProvider } from "app/_core/services/env-config.provider";

@Component({
    selector: "dodo-request-callback-dialog",
    templateUrl: "./request-callback-dialog.component.html",
    styleUrls: ["./request-callback-dialog.component.scss"],
    standalone: false
})
export class RequestCallbackDialogComponent implements OnInit {
	private product: string;
	private defaultParams: any;
	private url = "";
	public _callbackFormUrl: SafeResourceUrl;

	constructor(
		public dialogRef: MatDialogRef<RequestCallbackDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private __sanitizer: DomSanitizer,
		private __localStorageService: LocalStorageService,
		private __envConfigProvider: EnvConfigProvider
	) {
		const s = document.createElement("script");
		s.type = "text/javascript";
		s.innerHTML =
			"var ua = 'UA-1639020-1'; if (gaData && gaData['UA-1639020-14']) ua = 'UA-1639020-14'; ga('create', ua, 'auto'); ga(function(tracker) " +
			"{ var clientId = tracker.get('clientId'); var frameWindow = document.getElementById('request-callback-iframe').contentWindow; " +
			"frameWindow.postMessage(clientId, location.origin); });";
		document.body.appendChild(s);

		this.product = "Unknown";
		this.defaultParams = {
			source: "website_call_back_link",
			offer_id: "162",
			affiliate_id: "1533",
			aff_sub5: "P",
			affiliate_source: "Website",
		};
	}

	ngOnInit() {
		// utilize Tealium data layer
		if (window.utag && window.utag_data["product_category"]) {
			Object.assign(this.defaultParams, {
				transaction_id: window.utag_data["ut.session_id"],
			});
			this.product = window.utag_data["product_category"];
			if (window.utag_data["product_subcategory"]) {
				this.product =
					this.product +
					" - " +
					window.utag_data["product_subcategory"];
			}
		}
		const _url = (this.data && this.data.source === "hfc") ? (this.__envConfigProvider.hfcCallBackUrl()) : this.__envConfigProvider.callBackUrl();
		this.url = (this.data && this.data.paramName && this.data.paramValue) ?	(`${_url}?${this.data.paramName}=${this.data.paramValue}`) : `${_url}?`;
		Object.assign(
			this.defaultParams,
			this.__localStorageService.getFromSessionStorage("dm_query_params")
		);
		Object.keys(this.defaultParams).forEach((key) => {
			this.url = this.url + "&" + key + "=" + this.defaultParams[key];
		});
		this._callbackFormUrl = this.__sanitizer.bypassSecurityTrustResourceUrl(
			this.url
		);
	}

	public _closeDialog(): void {
		this.dialogRef.close();
	}
}
